<script>
import CommonTableComponent from "@/components/table.vue";
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  name: "notification_not_set",
  mixins: [pagination, tableSearch],
  components: {
    CommonTableComponent,
  },
  data() {
    return {
      filters: {
        page: 1,
        column: this.$route.query.column || "delivery_date",
        dir: this.$route.query.dir || "DESC"
      },
      busyGetData: false,
      notifications: [],
      isExpanded: false,
    };
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.busyGetData = true;
      const response = await this.$http.get(apiEndpoints.top_notification_manifest_relation_unsetting, {
        ...this.filters,
      });
      const {status, data} = response;
      this.busyGetData = false;
      if (status) {
        const result = data.result;
        this.notifications = this.$_.isEmpty(result.data) ? [] : result.data;
        const meta = this.$_.isEmpty(result.meta) ? [] : result.meta;
        this.setMeta(meta);
      }
    },
    updateUrlFilters() {
      this.getData()
    },
    toggleItem() {
      this.isExpanded = !this.isExpanded;
    }
  },
  watch: {
    'filters.page': {
      immediate: false,
      handler() {
        this.getData();
      },
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "引渡日",
          value: "delivery_date",
          sortable: true,
          width: 10,
          additionalClasses: "delivery_date"
        },
        {
          text: "マニフェスト番号",
          value: "manifest_number",
          sortable: true,
          width: 10,
          additionalClasses: "manifest_number"
        },
        {
          text: "1次/2次",
          value: "manifest_stage",
          sortable: true,
          width: 10,
          additionalClasses: "manifest_stage"
        },
        {
          text: "事業者",
          value: "discharger",
          sortable: true,
          width: 12,
          additionalClasses: "discharger"
        },
        {
          text: "事業場",
          value: "discharger_site",
          sortable: true,
          width: 12,
          additionalClasses: "discharger_site"
        },
        {
          text: "内容",
          value: "top_message",
          sortable: true,
          width: 40,
          additionalClasses: "top_message"
        },
      ];
    },
  }
};
</script>

<template>
  <div class="row">
    <b-overlay
      :show="busyGetData"
      rounded
      opacity="0.6"
      spinner-small
      spinner-variant="primary"
      class="d-inline-block"
    >
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div
              @click="toggleItem()"
              v-b-toggle.collapse-notification-not-set
              class="card-title mb-2 mt-2"
            >
              <span class="font-size-16">1次と2次関連付け未設定通知（{{ meta.total }}件）</span>
              <span :class="{'rotate': isExpanded}" class="icon">▼</span>
            </div>
            <b-collapse id="collapse-notification-not-set">
              <CommonTableComponent
              :height-class="`table-wrapper-500`"
              :scrollAble="notifications.length >= this.$constant.scroll_able_records">
                <thead class="table-light">
                <tr>
                  <th
                    :style="`width: ${item.width}`"
                    v-for="(item, index) in headers"
                    :key="index"
                    :class="getHeaderClass(item)"
                  >
                    <span v-if="item.sortable" @click="clickSort(item.value)">
                      {{ item.text }}
                      <i :class="getSortClass(item.value)"></i>
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in notifications" :key="index">
                  <td>
                    {{ item.delivery_date }}
                  </td>
                  <td>
                    <router-link :to="{name:'manifests.edit.number',params:{number:item.manifest_number}}">{{ item.manifest_number }}</router-link>
                  </td>
                  <td>
                    {{ item.manifest_stage }}
                  </td>
                  <td>
                    {{ item.discharger_name_abbreviated }}
                  </td>
                  <td>
                    {{ item.discharger_site_name_abbreviated }}
                  </td>
                  <td>
                    {{ item.top_message }}
                  </td>
                </tr>
                <tr v-if="!notifications.length && !busyGetData">
                  <td colspan="6" class="text-center">
                    お知らせはありません
                  </td>
                </tr>
                </tbody>
              </CommonTableComponent>
            </b-collapse>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
  <!-- end row -->
</template>
<style scoped>
.icon {
  float: right;
  transition: transform 0.3s;
}

.rotate {
  transform: rotate(-90deg);
}
.delivery_date {
  width:8%;
  min-width:50px;
}
.manifest_number {
  width:10%;
  min-width:50px;
}
.manifest_stage {
  width:5%;
  min-width:50px;
}
.discharger {
  width:20%;
  min-width:100px;
}
.discharger_site {
  width:20%;
  min-width:100px;
}.top_message {
  width:50%;
  min-width:100px;
}
</style>
